<template>
	<div class="container__pagination flex w-full content-between">
		<span class="flex items-center">
			{{ $t('exibindo') }} {{ localQuantityPerPage * atualPage - (localQuantityPerPage - 1) }} -
			{{
				localQuantityPerPage * atualPage > totalRecords
					? totalRecords
					: localQuantityPerPage * atualPage
			}}
			registros
		</span>
		<div class="container__pagination__pageinfo gap-1">
			<div class="flex">
				<label>{{ $t('exibir') }}</label>
				<select
					class="container__pagination__pageinfo__select"
					:value="localQuantityPerPage"
					@change="onSelectChange($event)"
				>
					<option
						v-for="(quantity, key) in quantityPerPageOptions"
						:key="key"
						:value="quantity"
					>
						{{ quantity }}
					</option>
				</select>
				<label> de {{ totalRecords }} registros</label>
			</div>
			<div class="container__pagination__pages">
				<i
					:class="[
						'fas fa-arrow-left container__pagination__elements__arrow',
						{
							'container__pagination__elements__arrow--disablled':
								atualPage === 1 && pageNumber === 1,
						},
					]"
					@click="onPreviousPage"
				/>
				<label>{{ atualPage }}</label>
				<i
					:class="[
						'fas fa-arrow-right container__pagination__elements__arrow',
						{
							'container__pagination__elements__arrow--disablled': isLastPage,
						},
					]"
					@click="onNextPage"
				/>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		/**
		 * Quantidade de registros por pagina
		 */
		quantityPerPage: Number,
		/**
		 * Opcoes que estarao disponiveis de quantos registros podem ser exibidos por pagina
		 */
		quantityPerPageOptions: Array,
		/**
		 * Numero total de registros
		 */
		totalRecords: Number,
		/**
		 * Se true, reseta o startIndex a 0 ao trocar de batch (para views que substituem modelList).
		 * Se false, mantém startIndex acumulando (para views que concatenam modelList).
		 */
		resetIndexOnBatchChange: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			atualPage: 1,
			startIndex: 0,
			pageNumber: 1,
			localQuantityPerPage: this.quantityPerPage,
			localTotalRecords: 100,
		}
	},
	computed: {
		maxPages() {
			return Math.ceil(this.localTotalRecords / this.localQuantityPerPage)
		},
		isLastPage() {
			// Calcula o índice final dos registros sendo exibidos
			const endIndex = this.startIndex + this.localQuantityPerPage
			// Só é última página se o índice final alcançou ou passou o total de registros
			return endIndex >= this.totalRecords
		},
	},
	watch: {
		// Watch for changes in the prop and update local copy
		quantityPerPage(newValue) {
			this.localQuantityPerPage = newValue
		},
	},
	created() {
		this.$emit('setStartEnd', this.startIndex)
	},
	methods: {
		onSelectChange(e) {
			const newQuantity = parseInt(e.target.value)
			this.localQuantityPerPage = newQuantity
			this.atualPage = 1
			this.pageNumber = 1
			this.localTotalRecords = 100
			this.startIndex = 0
			this.$emit('setQuantityPerPage', newQuantity)
			this.$emit('setStartEnd', this.startIndex)
			this.$emit('refreshTable', this.pageNumber, 100)
		},
		onPreviousPage() {
			// Se já está na primeira página do primeiro batch, não faz nada
			if (this.atualPage === 1 && this.pageNumber === 1) {
				return
			}

			if (this.atualPage !== 1) {
				this.atualPage--
				this.startIndex -= this.localQuantityPerPage
				if (this.startIndex < 0) {
					this.startIndex = 100 - this.localQuantityPerPage
					this.localTotalRecords = this.localTotalRecords - 100
					this.pageNumber--
					this.$emit('refreshTable', this.pageNumber, 100)
					this.$emit('setQuantityPerPage', this.localQuantityPerPage)
				}
				this.$emit('setStartEnd', this.startIndex)
			} else {
				this.pageNumber--
				this.$emit('refreshTable', this.pageNumber, 100)
				this.resetToFirstPage()
			}
		},
		onNextPage() {
			// Se já está na última página, não faz nada
			if (this.isLastPage) {
				return
			}

			if (this.atualPage !== this.maxPages) {
				this.atualPage++
				this.startIndex = this.startIndex + this.localQuantityPerPage
				this.$emit('setStartEnd', this.startIndex)
			} else {
				// Chegou no final do batch atual, precisa carregar mais dados
				this.pageNumber++
				this.localTotalRecords = this.localTotalRecords + 100
				this.atualPage++
				if (this.resetIndexOnBatchChange) {
					this.startIndex = 0
				} else {
					this.startIndex = this.startIndex + this.localQuantityPerPage
				}
				this.$emit('setStartEnd', this.startIndex)
				this.$emit('refreshTable', this.pageNumber, 100)
			}
		},
		resetToFirstPage() {
			this.startIndex = 0
			this.$emit('setStartEnd', this.startIndex)
		},

		resetToFirstPageInputHandle() {
			this.atualPage = 1
			this.pageNumber = 1
			this.localQuantityPerPage = 10
			this.localTotalRecords = 100
			this.startIndex = 0
			this.$emit('setStartEnd', this.startIndex)
		},
	},
}
</script>
<style>
.container__pagination {
	font-size: 0.75rem;
	display: flex;
	width: 100%;
	justify-content: space-between;
}

.container__pagination label {
	user-select: none;
}

.container__pagination__pageinfo,
.container__pagination__pages {
	display: flex;
	align-items: center;
}

.container__pagination__pageinfo__select {
	font-size: 0.75rem;
	height: 1rem;
	background-color: #ebecf0;
	border: none;
	margin: 0 0.2rem;
	padding: 0 0.2rem;
	user-select: none;
}

.container__pagination___pages {
	margin: 0 0.5rem;
}

.container__pagination__pages label {
	margin: 0.2rem;
}

.container__pagination__elements__arrow {
	font-size: 0.8rem;
	color: #636466;
	margin: 0 0.2rem;
	transition: transform 0.1s ease-in-out;
}

.container__pagination__elements__arrow:hover {
	color: rgb(var(--color-default));
	transform: scale(1.5);
}
.container__pagination__elements__arrow--disablled {
	color: #d7dadf;
	pointer-events: none;
	cursor: not-allowed;
}

.container__pagination__elements__arrow--disablled:hover {
	color: #d7dadf;
	transform: scale(1);
	cursor: not-allowed;
}
</style>
